<style lang="scss">
@import '../css/sub.scss';
</style>
<template>
  <div class="donga-audit">
    <audit-header></audit-header>
    <div class="audit-template sub-template">
      <div role="sub" class="audit-sub">
        <div id="sub-sections">
          <div class="visual-top reporting">
            <h2 class="page-tit">제보하기</h2>
            <p class="page-sub-tit pc-show">감사실과 제보자간의 쌍방향 소통방식으로 운영되며 동아쏘시오 그룹사 임직원 뿐만 아니라<br>고객, 협력회사 등 모든 이해관계자 여러분의 소중한 의견을 자유롭게 제안할 수 있는 곳으로 그룹사와 이해관계자<br>모두의 발전에 도움이 되도록 적극적인 참여 바랍니다.</p>
          </div>
          <div class="col-container pc-container">
            <div class="sub-contents">
              <div class="default-tab reporting-tab">
                <div class="tabs">
                  <button type="button" class="tab active">실명 제보</button>
                  <button type="button" class="tab" @click="showModal2=true">익명 제보</button>
                </div>
              </div>
                <section class="sub-section" id="reporting">
                  <div class="sub-column agree-column">
                    <h3 class="section-tit title">개인정보 수집•이용 동의</h3>
                    <p class="notice"><br><br>동아제약은 CLEAN:D를 통한 실명 제보의 접수 및 처리를 위하여 다음과 같이 개인정보를 수집·이용하고자 합니다.<br>내용을 확인하신 후 동의 여부를 선택하여 주시기 바랍니다.</p>
                    <div class="description">
                      <ol class="desc-list">
                        <li><span class="bold">• 수집·이용 목적: </span>실명 제보 접수, 제보 내용의 사실관계 확인·조사, 추가 문의 및 처리 결과 안내·확인, 처리 결과에 따른 포상 또는 형사조치(고소·고발) 시 인적증거 등록</li>
                        <li><span class="bold">• 수집·이용 항목: </span>이름, 이메일, 전화번호</li>
                        <li>
                          <span class="bold">• 보유 및 이용기간: </span>제보 처리에 필요한 기간 및 해당 제보의 종결처리가 완료된 날부터 2년<br>
                          <span style="font-style: italic;">(단, 그 이전이라도 처리목적이 달성되어 개인정보가 불필요하게 된 경우에는 지체 없이 파기합니다.)</span>
                        </li>
                        <li><span class="bold">• 동의 거부권 및 불이익 안내: </span>개인정보 수집·이용에 대한 동의를 거부할 권리가 있습니다. 단, 동의를 거부하시는 경우 실명 제보 접수 및 처리 결과 개별 안내는 제한되며, 익명 제보만 이용하실 수 있습니다.</li>
                        <li>종결처리 완료일은 회사가 해당 제보의 조사·처리 결과를 확정하고 시스템에 종결로 등록한 날을 의미합니다.</li>
                        <li>위 보유기간 이후에도 개인정보의 보관이 필요한 경우에는 별도의 적법한 처리근거를 확인하고 필요한 절차를 이행합니다. <span class="bold">본 동의만으로 보유기간을 무기한 연장하지 않습니다.</span> 다른 법령에 따라 보존하여야 하는 개인정보는 해당 법령에서 정한 기간 동안 분리하여 보관합니다.</li>
                        <li>제보 본문이나 첨부자료에는 제보와 무관한 개인정보를 기재하거나 첨부하지 않도록 유의하여 주시기 바랍니다. 본 동의는 다른 사람의 개인정보 처리에 대한 동의를 대신하지 않습니다.</li>
                      </ol>
                    </div>
                    <div class="agree-area">
                      <p class="notice">위 개인정보 수집·이용에 동의하십니까?</p>
                      <div class="agree-radio-area">
                        <span class="radio-half">
                          <input type="radio" class="default-radio" id="agree-radio-first" name="porsonal-inform-first" value="yes" v-model="realName">
                          <label for="agree-radio-first" class="default-label">동의합니다.</label>
                        </span>
                        <span class="radio-half">
                          <input type="radio" class="default-radio" id="agree-radio-second" name="porsonal-inform-first" value="no" v-model="realName">
                          <label for="agree-radio-second" class="default-label">동의하지 않습니다.</label>
                        </span>
                      </div>
                    </div>
                  </div>
                  <div class="sub-column agree-column second">
                    <h3 class="section-tit title">개인정보 제3자 제공 동의</h3>
                    <p class="notice"><br><br>동아제약은 제보 내용과 관련된 계열사에서 사실관계를 확인하고 제보를 처리할 필요가 있는 경우, 다음과 같이 개인정보를 제공하고자 합니다. 내용을 확인하신 후 동의 여부를 선택하여 주시기 바랍니다.</p>
                    <div class="description">
                      <ol class="desc-list">
                        <li><span class="bold">• 제공받는 자: </span>동아에스티, 비티젠, 동아오츠카, 용마로지스, 에스티팜, 한국신동공업, 동아에코팩, 동아참메드, 앱티스, 디에이아이, 아벤종합건설 중 해당 제보와 관련된 법인</li>
                        <li><span class="bold">• 제공받는 자의 이용 목적: </span>해당 회사 관련 제보의 사실관계 확인·조사, 추가 문의 및 처리 결과 안내·확인, 처리 결과에 따른 포상 또는 형사조치(고소·고발) 시 인적증거 등록</li>
                        <li><span class="bold">• 제공하는 개인정보 항목: </span>이름, 이메일, 전화번호 및 제보 본문·첨부자료 중 실제 제공하는 개인정보</li>
                        <li><span class="bold">• 제공받는 자의 보유 및 이용기간: </span>개인정보 처리 및 보유기간과 동일 (종결처리 완료일부터 2년)</li>
                        <li><span class="bold">• 동의 거부권 및 불이익 안내: </span>개인정보 제3자 제공에 대한 동의를 거부할 수 있습니다. 단, 동의를 거부하실 경우 이름·이메일·전화번호를 이용한 실명 제보는 이용할 수 없으며, 익명 제보만 이용하실 수 있습니다.</li>
                        <li>위 보유기간 이후에도 개인정보의 보관이 필요한 경우에는 제공받는 자가 별도의 적법한 처리근거를 확인하고 필요한 절차를 이행합니다. 본 동의만으로 보유기간을 무기한 연장하지 않습니다. 다른 법령에 따라 보존하여야 하는 개인정보는 해당 법령에서 정한 기간 동안 분리하여 보관합니다.</li>
                        <li>개인정보는 위에 표시된 제공받는 자에게 필요한 범위에서 제공하며, 모든 계열사에 일괄 제공하지 않습니다.</li>
                      </ol>
                    </div>
                    <div class="agree-area">
                      <p class="notice">위 개인정보 제3자 제공에 동의하십니까?</p>
                      <div class="agree-radio-area">
                        <span class="radio-half">
                          <input type="radio" class="default-radio" id="agree-radio-third" name="porsonal-inform-second" value="yes" v-model="anonymousName">
                          <label for="agree-radio-third" class="default-label">동의합니다.</label>
                        </span>
                        <span class="radio-half">
                          <input type="radio" class="default-radio" id="agree-radio-fourth" name="porsonal-inform-second" value="no" v-model="anonymousName">
                          <label for="agree-radio-fourth" class="default-label">동의하지 않습니다.</label>
                        </span>
                      </div>
                    </div>
                    <modal v-if="showModal" @close="showModal=false">
                      <h3 style="font-size: 17px;" slot="body">
                        1. [제보 처리 안내]<br>모든 제보는 접수순서대로 처리되면, 사실관계 확인 및 조치 완료까지 최소 2주에서 최대 1개월 소요됩니다. 제보자의 신원과 제보 내용은 철저히 보호되면, 제보로 인한 어떠한 불이익도 발생하지 않습니다.<br><br>
                        2. [제보 미진행(종결) 안내]<br>아래 항목에 해당하는 제보는 별도의 조사없이 처리가 종료될 수 있습니다.<br>
                        <span style="margin-left: 5px;">1) 구체적인 사실이나 근거가 없는 경우 (허위사실, 일방적 비방 등)</span><br>
                        <span style="margin-left: 5px;">2) 회사가 관여할 수 없는 개인의 사생활 영역인 경우</span>
                      </h3>
                      <button slot="footer" type="button" class="modal-button" @click="goPublicPage">
                          확인
                      </button>
                    </modal>
                    <modal v-if="showModal2" @close="showModal2=false">
                      <h3 style="font-size: 17px;" slot="body">
                        1. [제보 처리 안내]<br>모든 제보는 접수순서대로 처리되면, 사실관계 확인 및 조치 완료까지 최소 2주에서 최대 1개월 소요됩니다. 제보자의 신원과 제보 내용은 철저히 보호되면, 제보로 인한 어떠한 불이익도 발생하지 않습니다.<br>
                        2. [제보 미진행(종결) 안내]<br>아래 항목에 해당하는 제보는 별도의 조사없이 처리가 종료될 수 있습니다.<br>
                        <span style="margin-left: 5px;">1) 구체적인 사실이나 근거가 없는 경우 (허위사실, 일방적 비방 등)</span><br>
                        <span style="margin-left: 5px;">2) 회사가 관여할 수 없는 개인의 사생활 영역인 경우</span>
                      </h3>
                      <button slot="footer" type="button" class="modal-button" @click="goPrivatePage">
                          확인
                      </button>
                    </modal>
                    <div class="agree-btn-area">
                      <button type="button" class="agree-btn" @click="agreeRealName">다음</button>
                    </div>
                  </div>
                </section>
            </div>
          </div>
        </div>
      </div>
    </div>
    <audit-footer></audit-footer>
  </div>
</template>
<script>
import AuditHeader from '@/components/AuditHeader'
import AuditFooter from '@/components/AuditFooter'
import Modal from '@/components/Modal'
export default {
  name: 'Reporting',
  components: {
    'audit-header': AuditHeader,
    'audit-footer': AuditFooter,
    'modal': Modal
  },
  data () {
    return {
      realName: '',
      anonymousName: '',
      showModal: false,
      showModal2: false
    }
  },
  methods: {
    agreeRealName: function () {
      if (this.realName === 'yes' && this.anonymousName === 'yes') {
        this.showModal = true
      } else {
        alert('개인정보 수집및 처리, 제 3자 제공의 동의시 진행됩니다.')
      }
    },
    goPrivatePage () {
      this.$router.push('/reportsecond02')
    },
    goPublicPage () {
      this.$router.push('/reportsecond')
    }
  }
}
</script>

<style scoped>
.modal-button {
  font-size: 18px;
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/pages/Reporting.vue